var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrivateNavigationDrawer'),_c('div',{staticClass:"ml-12",class:{ 'nav-expanded': !_vm.isMini }},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }